// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicTurnitinModal } from "./plasmic/cps/PlasmicTurnitinModal";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { showTurnitinResults, turnitinLinkRequest } from "../redux/reducers/turnitin";
import axios from 'axios';
import { API_LINK, SERVER_LINK, STATUSES } from '../constants';
import { contentItemSuccess } from "../redux/reducers/contentList";
import { addComponentStatusRequest, saveStatus } from "../redux/reducers/addComponentStatus";
import { selectUserContent } from "../redux/reducers/userProgramsFull";
const API = `${API_LINK}api`;

function TurnitinModal_(props, ref) {
  const refreshItem = async(library_id)=>{
    var result =  await axios({
      method: 'get',
      url: `${API}/user/${props.login.user.userId}/getComponent?component_id=${library_id}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
    })
    console.log('Turnit in content', result.data.data)
    props.contentItemSuccess(result.data.data.component[0].content[0])
  }

  const handleClick = async() => {
    console.log('My Turn 1',props.turnitin.results?.library_id )
    props.selectUserContent(props.turnitin.results?.library_id);
    props.saveStatus(STATUSES.ready.value);
    props.addComponentStatusRequest();
    const data = JSON.stringify({
      "viewer_user_id": props.login.user.userId,
      "locale": "en-GB",
      "viewer_default_permission_set": "LEARNER",
      "author_metadata_override": {
        "family_name": props.login.user.lastName,
        "given_name": props.login.user.firstName
      }
    });
    console.log('Turnit in content3',  props.turnitin.results)
    var result =  await axios({
      method: 'get',
      url: `${API}/tii_get_results`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${props.login.token}`,
      },
      params: {
        tii_data: data,
        statement_id: props.turnitin.results?.tii_id
      },
    })
    console.log('My Turn 2',result.data )
    window.open(result.data.viewer_url)
  };


  return<div>
          {props.turnitin.showTurnitinResults && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:1000000}}>
          <PlasmicTurnitinModal root={{ ref }} {...props} 
          txtOverall = {props.turnitin.results?.overall_match_percentage+'%'}
          txtInternet = {props.turnitin.results?.internet_match_percentage+'%'}
          txtPublication = {props.turnitin.results?.publication_match_percentage+'%'}
          txtSubmitted = {props.turnitin.results?.submitted_works_match_percentage+'%'}
          btnClose = {{
            onClick:(e)=>{
              props.showTurnitinResults(false)
              refreshItem(props.turnitin.results?.library_id)
            }
          }}
          btnCloseBottom2 = {{
            onClick:(e)=>{
              handleClick()
  
            }
          }}
          btnCloseBottom3 = {{
            onClick:(e)=>{
             // handleClick()
              props.showTurnitinResults(false)
              refreshItem(props.turnitin.results?.library_id)
            }
          }}
          />
          </div>}
    </div>;
}

const TurnitinModal = React.forwardRef(TurnitinModal_);


const mapStateToProps = state => ({
  login: state.loginReducer,
  turnitin: state.turnitinReducer
});
const mapDispatchToProps = dispatch => ({
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  showTurnitinResults: value => dispatch(showTurnitinResults(value)),
  contentItemSuccess: value => dispatch(contentItemSuccess(value)),
  turnitinLinkRequest: value => dispatch(turnitinLinkRequest(value)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TurnitinModal);
